/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page SubscriberId DcRule Tab component
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.12.0
 */

import { Fragment } from 'react';

import { Skeleton } from '../../../../../components/common';
import { useSubscriberIdContext } from '../../../context';
import SubscriberIdError from '../../SubscriberIdError';
import { useGetDcRulesQuery } from '../store';
import { SubscriberIdDcRulesStyled } from './styled/SubscriberIdDcRulesStyled';
import SubscriberIdDcRuleAccordion from './SubscriberIdDcRuleAccordion';
import SubscriberIdDcRuleList from './SubscriberIdDcRuleList';
import SubscriberIdDcRuleNotifications from './SubscriberIdDcRuleNotifications';
import SubscriberIdDcRuleSchedule from './SubscriberIdDcRuleSchedule';
import { SubscriberIdDcRuleListSkeleton } from './SubscriberIdDcRuleSkeleton';

const SubscriberIdDcRule = () => {

    const { subscriberId } = useSubscriberIdContext();

    const { data, isFetching, isSuccess, error, refetch } = useGetDcRulesQuery({ subscriberId });

    if (error || (!data && isSuccess)) return <SubscriberIdError refetch={refetch}/>;
    if (isFetching) return <Skeleton isLoading count={1} render={SubscriberIdDcRuleListSkeleton}/>;
    if (!data) return null;

    return (
        <SubscriberIdDcRulesStyled>
            <SubscriberIdDcRuleList/>
            {
                data.activeRule?.rules.length && (
                    <Fragment>
                        <div className="subscriber-dc-rules__block">
                            <SubscriberIdDcRuleAccordion/>
                        </div>

                        <div className="subscriber-dc-rules__block subscriber-dc-rules__notification">
                            <SubscriberIdDcRuleNotifications/>
                        </div>

                        <SubscriberIdDcRuleSchedule/>
                    </Fragment>
                )
            }
        </SubscriberIdDcRulesStyled>
    );
};

export default SubscriberIdDcRule;
